import { ChannelOption } from '../CampaignWizard/Types'

const HOURS_48_IN_MS = 48 * 60 * 60 * 1000

export const getDefaultPostAtDate = (originalPostAt?: string): string => {
  const now = Date.now()
  const minPostTime = now + HOURS_48_IN_MS

  // Add 48h onto original doc date OR now
  const baseTime = originalPostAt ? new Date(originalPostAt).getTime() : now
  const derivedTime = baseTime + HOURS_48_IN_MS

  // Ensure post time is at least 48h in the future
  const postTime = Math.max(derivedTime, minPostTime)

  return new Date(postTime).toISOString()
}

export const ensureChannelsHavePostAt = (channels?: ChannelOption[], originalPostAt?: string): ChannelOption[] => {
  return (
    channels?.map((channel) => ({
      ...channel,
      post_at: channel.post_at || getDefaultPostAtDate(originalPostAt),
    })) || []
  )
}
